import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { orange } from "@mui/material/colors";
import { HomeCategory } from "../types/homeCategoryType";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../State/Store";
import { createHomeCategories } from "../State/admin/adminSlice";
import { homeCategories } from "../customer/data/homeCategories";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(
  name: string,
  calories: number,
  fat: number,
  carbs: number,
  protein: number
) {
  return { name, calories, fat, carbs, protein };
}


export default function HomePageTable({data}:{data:HomeCategory[]|undefined}) {
  const {deal} =useAppSelector(store=>store)
  const dispatch = useAppDispatch()
  useEffect(() => { 
    if(deal.dealCreated||deal.dealDeleted){
      dispatch(createHomeCategories(homeCategories))
    }
   },[deal.dealCreated,deal.dealDeleted])
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>No</StyledTableCell>
            <StyledTableCell>Id</StyledTableCell>
            <StyledTableCell>Image</StyledTableCell>
            <StyledTableCell align="right">Category</StyledTableCell>
            <StyledTableCell align="right">Update</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((category,index) => (
            <StyledTableRow key={category.id}>
              <StyledTableCell component="th" scope="row">
                {index+1}
              </StyledTableCell>
              <StyledTableCell>{category.id}</StyledTableCell>
              <StyledTableCell>
                <img className="w-20 rounded-md" src={category.image} alt="" />
              </StyledTableCell>
              <StyledTableCell align="right">{category.categoryId}</StyledTableCell>
              <StyledTableCell align="right">
                <Button sx={{color:orange[500]}}>
                  <Edit />
                </Button>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
